import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  appInitFailureTitle: {
    id: 'uPvtGG',
    defaultMessage: 'Failed to load data',
    description: 'Title for notification when app initialization API calls fail after retries',
  },
  warehousesLoadFailure: {
    id: 'K11KWi',
    defaultMessage: 'Inventory warehouses could not be loaded. Please refresh the page or contact support if the issue persists.',
    description: 'Content for notification when inventory warehouses API call fails after retries',
  },
  totesLoadFailure: {
    id: 'KaZ7RB',
    defaultMessage: 'Totes could not be loaded. Please refresh the page or contact support if the issue persists.',
    description: 'Content for notification when totes API call fails after retries',
  },
});
